export const MODALS = {
  REFERRAL: 'referral',
}
